const ENROLLMENT_TYPES = Object.freeze({
    DEPOSIT: 'DEPOSIT'
});

export default ENROLLMENT_TYPES;